/**
 * Converts a Uint8Array to an ArrayBuffer.
 * Creates a new ArrayBuffer with exactly the right size.
 */
export const toArrayBuffer = (uint8Array: Uint8Array): ArrayBuffer => {
  return uint8Array.buffer.slice(
    uint8Array.byteOffset,
    uint8Array.byteOffset + uint8Array.byteLength
  ) as ArrayBuffer;
};
